export default "__VITE_ASSET__c14881e9__"